import { Link } from "react-router-dom";

import "./Topbar.scss";

const Topbar = (props) => {
  const homelinkStyle = {
    color: "#eee",
    textDecoration: "none",
  };

  return (
    <nav className="menu border-bottom" id="Topbar">
      <ul className="menu-left">
        <li className="text">
          <Link to="/" style={homelinkStyle}>
            Dashboard
          </Link>
        </li>
      </ul>
      <ul className="menu-right">
        <li className="text">{props.userName}</li>
        {!props.accessToken && (
          <li className="topbar-button" onClick={props.signin}>
            Signin
          </li>
        )}
        {props.accessToken && (
          <li className="topbar-button" onClick={props.signout}>
            Signout
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Topbar;
